var Highcharts = require('highcharts/highcharts');
require('highcharts/modules/xrange')(Highcharts);

import { ViewDeliverablesModalConfig, DeliverableChildExtended, DeliverableParentExtended, DeliverableStatusHistory } from "./deliverables-tracker.objects";
import { PickListItemSorted, JsonItem, UserRequestExtended, UpdateGroupRequest, PickListItem, AppUserExtended, AppUserGroupCommittee, UpdateUserRequest, AppUserRedacted } from "../../list-management/scripts/list-management.objects";
import { getDisplayDate, FormatDate } from "../../../shared/scripts/date-functions"
import _ from "lodash";
import { TableColumnGroup, TableColumnVisibilityControllerV2 } from "../../../shared/scripts/table-column-visibility";
import { DocumentTreeLoaderDeliverables } from "../../../shared/components/document-tree/document-tree-loader";
import { DocumentInfoV2 } from "../../../shared/components/document-tree/document-tree.objects"


export class ViewDeliverablesController {
    // Config variables
    id: string
    modalId: string;
    getAttachmentsRoute: string;
    getCommentsRoute: string;

    // Const vars
    parentTab: JQuery<HTMLElement>;
    parentTabContainer: JQuery<HTMLElement>;
    childTab: JQuery<HTMLElement>;
    childTabContainer: JQuery<HTMLElement>;
    attachmentTab: JQuery<HTMLElement>;
    attachmentContainer: JQuery<HTMLElement>;

    currentParent: DeliverableParentExtended;
    currentChild: DeliverableChildExtended;

    // Modal Parent Items
    currentParentTimelineChart: any;
    currentParentChildElementTable: any;
    currentParentStatusHistoryTable: any;
    currentParentDocuments: DocumentInfoV2[] = undefined;

    // Modal Child Items
    currentChildDocuments: DocumentInfoV2[] = undefined;
    currentChildStatusHistoryTable: any;

    pickLists: JsonItem[] = [];

    constructor(config: ViewDeliverablesModalConfig) {
        this.id = "deliverables-view-controller";
        this.modalId = config.modalIdTarget;      
        this.getAttachmentsRoute = config.getAttachmentsRoute;
        this.getCommentsRoute = config.getCommentsRoute;

        this.generateHtml();

        let modal = $(`#${this.modalId}`);
        this.parentTab = modal.find("#deliverable-parent-tab");
        this.parentTabContainer = modal.find("#deliverable-parent-tab-content");
        this.childTab = modal.find("#deliverable-child-tab");
        this.childTabContainer = modal.find("#deliverable-child-tab-content");
        this.attachmentTab = modal.find("#deliverable-attachment-tab");
        this.attachmentContainer = modal.find("#deliverable-attachment-tab-content");

        this.initializeModalTabs();
    }

    initialize(pickLists: JsonItem[], parent: DeliverableParentExtended, child: DeliverableChildExtended = undefined): void {
        this.pickLists = pickLists;
        this.currentParent = parent;
        this.currentChild = child;

        this.updateParentModalContent();
        this.updateChildModalContent();
        this.updateModalTabVisibility();
        this.initializeInnerTabs();
    }

    // Base HTML
    generateHtml(): void {
        let modal = $(`#${this.modalId}`);
        let modalHeader = modal.find(`.modal-header`);
        let modalBody = modal.find(`.modal-body`);

        let headerContent = `
            <div class="deliverables-page-tabs">
                <ul class="nav nav-tabs border-0">
                    <li class="nav-item">
                        <a class="nav-link active" id="deliverable-parent-tab" data-toggle="tab" href="#deliverable-parent-tab-content" role="tab" aria-controls="deliverable-parent-tab-content" aria-selected="true">Parent</a>
                    </li>
                    <li class="nav-item d-none">
                        <a class="nav-link" id="deliverable-child-tab" data-toggle="tab" href="#deliverable-child-tab-content" role="tab" aria-controls="deliverable-child-tab-content" aria-selected="false">
                            Child <span class="pl-4 tab-close-icon"><i class="fa-solid fa-xmark"></i></span>
                        </a>
                    </li>
                    <li class="nav-item d-none">
                        <a class="nav-link" id="deliverable-attachment-tab" data-toggle="tab" href="#deliverable-attachment-tab-content" role="tab" aria-controls="deliverable-attachment-tab-content" aria-selected="false">
                            View Attachment <span class="pl-4 tab-close-icon"><i class="fa-solid fa-xmark tab-close-icon"></i></span>
                        </a>
                    </li>
                </ul>
            </div>
            <div class="close-deliverable-btn-container">
                <div class="close-deliverable-btn my-1 mx-2" data-dismiss="modal" aria-label="Close">
                    <i class="fa-solid fa-xmark fa-lg"></i>
                </div>
            </div>
        `;

        let bodyContent = `
            <div class="tab-content">
                <div class="tab-pane fade show active" id="deliverable-parent-tab-content" role="tabpanel" aria-labelledby="deliverable-parent-tab">
                    <div class="deliverable-modal-header">
                        
                    </div>
                    <div class="deliverable-modal-tab-content mt-4">

                    </div>
                </div>
                <div class="tab-pane fade" id="deliverable-child-tab-content" role="tabpanel" aria-labelledby="deliverable-child-tab">
                    <div class="deliverable-modal-header">

                    </div>
                    <div class="deliverable-modal-tab-content mt-4">

                    </div>
                </div>
                <div class="tab-pane fade" id="deliverable-attachment-tab-content" role="tabpanel" aria-labelledby="deliverable-attachment-tab">
                    <div class="deliverable-modal-tab-content">
                        <div class="deliverable-attachment-title">
                            <span id="deliverable-attachment-name">Attachment Name</span>
                        </div>
                        <div class="mt-3" style="text-align: center;">
                            <iframe id="deliverable-attachment-iframe"
                                    src=""
                                    style="width:100%; height:70vh;" frameborder="0" allowfullscreen="true"></iframe>
                        </div>
                    </div>
                </div>
            </div>
        `

        modalHeader.empty().html(headerContent);
        modalBody.empty().html(bodyContent);
    }

    initializeModalTabs(): void {
        let modalTabs = $(`#${this.modalId}`).find(".deliverables-page-tabs");
        modalTabs.find(".tab-close-icon").on("click", (e) => {
            // Make sure event doesn't bubble up
            e.preventDefault();
            e.stopPropagation();

            let tabTarget = $(e.currentTarget);
            let tabContainer = tabTarget.closest(".nav-item");
            let nearestVisibileTab = tabContainer.prevAll(":not(.d-none)").first();
            let nearestTarget = nearestVisibileTab.find(".nav-link");

            nearestTarget.tab("show");
            tabContainer.addClass("d-none");
        })
    }

    updateModalTabVisibility(): void {
        // Always hide attachment tab when opening
        this.attachmentTab.closest(".nav-item").addClass('d-none');

        if (this.currentChild && this.currentParent) {
            this.childTab.closest(".nav-item").removeClass("d-none");
            this.childTab.tab("show");
        }
        else {
            this.childTab.closest(".nav-item").addClass("d-none");
            this.parentTab.tab("show");
        }
    }

    updateParentModalContent(): void {
        // Refresh
        this.currentParentTimelineChart = undefined;
        this.currentParentChildElementTable = undefined;
        this.currentParentStatusHistoryTable = undefined;
        this.currentParentDocuments = undefined;

        // Title & Header
        let headerTarget = this.parentTabContainer.find(".deliverable-modal-header");

        let trlContent = "";
        if (this.currentParent.DeliverableParent.TrlTagId) {
            trlContent = `
                <div class="col-auto ml-auto">
                    <div class="pill-list-container">
                        <div class="pill-list-item white">${this.renderPickListItem(this.currentParent.DeliverableParent.TrlTagId, "pl-trl-tag", false, true)}</div>
                    </div>
                </div>
            `
        }

        let headerContent = `
            <div class="row justify-content-between">
                <div class="col mb-3">
                    <div class="deliverable-modal-title">${this.currentParent.DeliverableParent.Description}</div>
                </div>
                <div class="col-auto text-right mb-3">
                    <span class="font-weight-600 pr-2">Last Updated:</span> ${getDisplayDate(this.currentParent.LastUpdated)}
                </div>
            </div>
            <div class="row align-items-center">
                <div class="col-auto">${this.createStatusBar()}</div>
                <div class="col-auto font-size16 font-weight-700">${this.renderPickListItem(this.currentParent.DeliverableParent.CenterId, "pl-center", false, false)}</div>
                <div class="col-auto pill-list-container">
                    <div class="pill-list-item white">${this.renderPickListItem(this.currentParent.DeliverableParent.CategoryId, "pl-deliverable-category", false, true)}</div>
                </div>
                ${trlContent}
            </div>
        `

        headerTarget.empty().html(headerContent);

        // Inner Tabs
        let bodyTarget = this.parentTabContainer.find(".deliverable-modal-tab-content");
        let innerTabs = `
            <div class="deliverables-modal-inner-tabs border-bottom">
                <ul class="nav nav-tabs border-0">
                    <li class="nav-item">
                        <a class="nav-link active" id="deliverable-parent-timeline-tab" data-toggle="tab" href="#deliverable-parent-timeline-tab-content" role="tab" aria-controls="deliverable-parent-timeline-tab-content" aria-selected="true">Timeline</a>
                    </li>
                    ${this.currentParent.VirusFamilyIds || this.currentParent.DeliverableParent.TargetIds ?
                        `<li class="nav-item">
                            <a class="nav-link" id="deliverable-parent-virus-focus-tab" data-toggle="tab" href="#deliverable-parent-virus-focus-tab-content" role="tab" aria-controls="deliverable-parent-virus-focus-tab-content" aria-selected="false">Virus Focus</a>
                        </li>` : ""
                    }
                    <li class="nav-item">
                        <a class="nav-link" id="deliverable-parent-child-elements-tab" data-toggle="tab" href="#deliverable-parent-child-elements-tab-content" role="tab" aria-controls="deliverable-parent-child-elements-tab-content" aria-selected="false">Child Elements</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="deliverable-parent-comment-tab" data-toggle="tab" href="#deliverable-parent-comment-tab-content" role="tab" aria-controls="deliverable-parent-comment-tab-content" aria-selected="false">Comments</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="deliverable-parent-status-history-tab" data-toggle="tab" href="#deliverable-parent-status-history-tab-content" role="tab" aria-controls="deliverable-parent-status-history-tab-content" aria-selected="false">Status History</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" id="deliverable-parent-attachments-tab" data-toggle="tab" href="#deliverable-parent-attachments-tab-content" role="tab" aria-controls="deliverable-parent-attachments-tab-content" aria-selected="false">Attachments</a>
                    </li>
                </ul>
            </div>
            <div class="tab-content deliverables-modal-inner-tab-content">
                <div class="tab-pane fade show active" id="deliverable-parent-timeline-tab-content" role="tabpanel" aria-labelledby="deliverable-parent-timeline-tab">
                    ${this.renderDeliverableItem(this.currentParent, 2)}
                </div>
                <div class="tab-pane fade" id="deliverable-parent-virus-focus-tab-content" role="tabpanel" aria-labelledby="deliverable-parent-virus-focus-tab">
                    ${this.renderDeliverableItem(this.currentParent, 3)}
                </div>
                <div class="tab-pane fade" id="deliverable-parent-child-elements-tab-content" role="tabpanel" aria-labelledby="deliverable-parent-child-elements-tab">
                    ${this.renderDeliverableItem(this.currentParent, 4)}
                </div>
                <div class="tab-pane fade" id="deliverable-parent-comment-tab-content" role="tabpanel" aria-labelledby="deliverable-parent-comment-tab-tab">
                    ${this.renderDeliverableItem(this.currentParent, 7)}
                </div>
                <div class="tab-pane fade" id="deliverable-parent-status-history-tab-content" role="tabpanel" aria-labelledby="deliverable-parent-status-history-tab">
                    ${this.renderDeliverableItem(this.currentParent, 5)}
                </div>
                <div class="tab-pane fade" id="deliverable-parent-attachments-tab-content" role="tabpanel" aria-labelledby="deliverable-parent-attachments-tab">
                    ${this.renderDeliverableItem(this.currentParent, 6)}
                </div>
            </div>
        `;

        bodyTarget.empty().html(innerTabs);
    }

    updateChildModalContent(): void {
        // Refresh
        this.currentChildDocuments = undefined;
        this.currentChildStatusHistoryTable = undefined;

        let headerTarget = this.childTabContainer.find(".deliverable-modal-header");

        if (this.currentChild) {
            let statusColor = `grey`
            let statusIcon = `<i class="fa-regular fa-circle"></i>`
            if (this.currentChild.IsComplete) {
                statusColor = "white-green";
                statusIcon = `<i class="fa-solid fa-circle-check"></i>`
            }
            else if (this.currentChild.IsOngoing) {
                statusColor = "white"
                statusIcon = `<i class="fa-solid fa-circle-half-stroke"></i>`;
            }

            let headerContent = `
                <div class="row justify-content-between">
                    <div class="col mb-3">
                        <div class="deliverable-modal-title">${this.currentChild.DeliverableChild.Description}</div>
                    </div>
                    <div class="col-auto text-right mb-3">
                        <span class="font-weight-600 pr-2">Last Updated:</span> ${getDisplayDate(this.currentChild.LastUpdated)}
                    </div>
                </div>
                <div class="row align-items-center">
                    <div class="col-auto pill-list-container">
                        <div class="pill-list-item ${statusColor}"><span class="pr-2">${statusIcon}</span> ${this.renderDeliverableChildItem(this.currentChild, 1)}</div>
                    </div>
                    <div class="col-auto font-size16 font-weight-700">${this.renderPickListItem(this.currentParent.DeliverableParent.CenterId, "pl-center", false, false)}</div>
                    <div class="col-auto pill-list-container">
                        <div class="pill-list-item white">${this.renderPickListItem(this.currentParent.DeliverableParent.CategoryId, "pl-deliverable-category", false, true)}</div>
                    </div>
                </div>
            `

            headerTarget.empty().html(headerContent);
        }
        else {
            headerTarget.empty();
        }

        // Inner Tabs
        let bodyTarget = this.childTabContainer.find(".deliverable-modal-tab-content");

        if (this.currentChild) {
            let innerTabs = `
                <div class="deliverables-modal-inner-tabs border-bottom">
                    <ul class="nav nav-tabs border-0">
                        <li class="nav-item">
                            <a class="nav-link active" id="deliverable-child-overview-tab" data-toggle="tab" href="#deliverable-child-overview-tab-content" role="tab" aria-controls="deliverable-child-overview-tab-content" aria-selected="true">Overview</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="deliverable-child-comments-tab" data-toggle="tab" href="#deliverable-child-comments-tab-content" role="tab" aria-controls="deliverable-child-comments-tab-content" aria-selected="false">Comments</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="deliverable-child-status-history-tab" data-toggle="tab" href="#deliverable-child-status-history-tab-content" role="tab" aria-controls="deliverable-child-status-history-tab-content" aria-selected="false">Status History</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" id="deliverable-child-attachments-tab" data-toggle="tab" href="#deliverable-child-attachments-tab-content" role="tab" aria-controls="deliverable-child-attachments-tab-content" aria-selected="false">Attachments</a>
                        </li>
                    </ul>
                </div>
                <div class="tab-content deliverables-modal-inner-tab-content">
                    <div class="tab-pane fade show active" id="deliverable-child-overview-tab-content" role="tabpanel" aria-labelledby="deliverable-child-overview-tab">
                        ${this.renderDeliverableChildItem(this.currentChild, 5)}
                    </div>
                    <div class="tab-pane fade" id="deliverable-child-comments-tab-content" role="tabpanel" aria-labelledby="deliverable-child-comments-tab">
                        ${this.renderDeliverableChildItem(this.currentChild, 7)}
                    </div>
                    <div class="tab-pane fade" id="deliverable-child-status-history-tab-content" role="tabpanel" aria-labelledby="deliverable-child-status-history-tab">
                        ${this.renderDeliverableChildItem(this.currentChild, 8)}
                    </div>
                    <div class="tab-pane fade" id="deliverable-child-attachments-tab-content" role="tabpanel" aria-labelledby="deliverable-child-attachments-tab">
                        ${this.renderDeliverableChildItem(this.currentChild, 6)}
                    </div>
                </div>
            `;

            bodyTarget.empty().html(innerTabs);
        }
        else {
            bodyTarget.empty();
        }

        if (this.currentChild) {
            this.initializeInnerChildTabs();
        }
    }

    initializeInnerTabs(): void {
        this.createParentTimeline();
        this.createParentChildTable();
        this.createParentStatusHistoryTable();
        // Modal Tabs
        $(`#deliverable-parent-tab`).on('shown.bs.tab', () => {
            if (this.currentParentChildElementTable) {
                this.currentParentChildElementTable.columns.adjust().draw();
            }
            if (this.currentParentTimelineChart) {
                this.currentParentTimelineChart.reflow();
            }
        })
        $(`#deliverable-child-tab`).on('show.bs.tab', () => {

        })

        // Inner Tabs
        $(`#deliverable-parent-child-elements-tab`).on('shown.bs.tab', () => {
            if (this.currentParentChildElementTable) {
                this.currentParentChildElementTable.columns.adjust().draw();
            }
        });

        $(`#deliverable-parent-timeline-tab`).on('shown.bs.tab', () => {
            if (this.currentParentTimelineChart) {
                this.currentParentTimelineChart.reflow();
            }
        });

        $(`#deliverable-parent-status-history-tab`).on('shown.bs.tab', () => {
            if (this.currentParentStatusHistoryTable) {
                this.currentParentStatusHistoryTable.columns.adjust().draw();
            }
        });

        $(`#deliverable-parent-attachments-tab`).on('shown.bs.tab', async () => {
            if (!this.currentParentDocuments) {
                await this.createParentAttachments();
            }
        });

        // Internal Items
        $(`#${this.modalId}`).find(".comment-child-link").on("click", (e) => {
            let commentInfo = $(e.currentTarget);
            let childId = commentInfo.data("childId");
            if (childId) {
                let foundChild = this.currentParent.DeliverableChildren.find(child => child.DeliverableChild.Id.toString() == childId);
                if (foundChild) {
                    this.currentChild = foundChild;

                    // Update the Child Tab and open the tab
                    this.updateChildModalContent();
                    this.childTab.closest(".nav-item").removeClass("d-none");
                    this.childTab.tab("show");
                }
            }
        })
    }

    initializeInnerChildTabs(): void {
        this.createChildStatusHistoryTable();

        $(`#deliverable-child-attachments-tab`).on('shown.bs.tab', async () => {
            if (!this.currentChildDocuments) {
                await this.createChildAttachments();
            }
        });

        $(`#deliverable-child-status-history-tab`).on('shown.bs.tab', () => {
            if (this.currentChildStatusHistoryTable) {
                this.currentChildStatusHistoryTable.columns.adjust().draw();
            }
        })
    }

    createParentTimeline(): void {
        // Timeline
        let seriesOptions = ['Planned'];
        let chartHeight: number = 150;
        let plannedStart = new Date(this.currentParent.DeliverableParent.PlannedStartDate);
        let plannedEnd = new Date(this.currentParent.DeliverableParent.PlannedEndDate);
        let actualStart = new Date(this.currentParent.DeliverableParent.ActualStartDate);
        let actualEnd = new Date(this.currentParent.DeliverableParent.ActualEndDate);
        let dateData = [
            {
                x: Date.UTC(plannedStart.getFullYear(), plannedStart.getMonth(), plannedStart.getDate()),
                x2: Date.UTC(plannedEnd.getFullYear(), plannedEnd.getMonth(), plannedEnd.getDate()),
                y: 0
            }
        ]
        if (actualStart.getFullYear() > 2000 && actualEnd.getFullYear() > 2000) {
            seriesOptions = ['Planned', 'Actual'];
            dateData.push({
                x: Date.UTC(actualStart.getFullYear(), actualStart.getMonth(), actualStart.getDate()),
                x2: Date.UTC(actualEnd.getFullYear(), actualEnd.getMonth(), actualEnd.getDate()),
                y: 1
            });
            chartHeight = 200;
        }

        let options = {
            chart: {
                type: 'xrange',
                height: chartHeight
            },
            credits: {
                enabled: false,
            },
            legend: {
                enabled: false,
            },
            title: {
                text: ''
            },
            xAxis: {
                type: 'datetime',
                minTickInterval: 3600 * 24 * 30 * 1000,//time in milliseconds
                minRange: 3600 * 24 * 30 * 1000,
                ordinal: false, //this sets the fixed time formats
                maxPadding: 0.05,
                labels: {
                    style: {
                        color: '#0f222f',
                    },
                    formatter: function () {
                        return Highcharts.dateFormat('%b %Y', this.value);
                    }
                }
            },
            yAxis: {
                title: {
                    text: ''
                },
                categories: seriesOptions,
                reversed: true,
                labels: {
                    style: {
                        color: '#0f222f',
                        fontSize: 14
                    }
                } 
            },
            series: [{
                type: "xrange",
                name: this.currentParent.DeliverableParent.Description,
                //pointPadding: 0,
                //groupPadding: 0,
                borderColor: 'gray',
                pointWidth: 25,
                data: dateData,
                dataLabels: {
                    enabled: true
                },
                tooltip: {
                    xDateFormat: '%Y-%m-%d',
                    headerFormat: "",
                    pointFormatter: function () {
                        let point = this;
                        let msDay = 24 * 60 * 60 * 1000
                        let x1Date = new Date(point.x + msDay);
                        let x2Date = new Date(point.x2 + msDay);
                        let x1DateDisplay = getDisplayDate(x1Date);
                        let x2DateDisplay = getDisplayDate(x2Date);
                        return `<span style="color:${point.color};"> ● </span> <b> ${point.yCategory}</b><br> ${x1DateDisplay} - ${x2DateDisplay} <br>`
                    }
                }
            }]

        }

        this.currentParentTimelineChart = Highcharts.chart('deliverables-parent-timeline-chart', options);
    }

    createParentChildTable(): void {
        let id = `view-deliverable-children-table-${this.currentParent.DeliverableParent.Id}`;

        let tableColumns = [
            { data: null, title: "Description", className: `text-left font-size12 table-column-lg lh-normal inner-table-child-link`, render: (data: DeliverableChildExtended) => { return data.DeliverableChild.Description } },
            { data: null, title: "Affiliation", className: 'center-core-project text-left font-size12 lh-normal', render: (data) => { return this.renderDeliverableChildItem(data, 3) } },
            { data: null, title: "Stage", className: 'stage text-left font-size12 lh-normal', render: (data) => { return this.renderDeliverableChildItem(data, 1) } },
            { data: null, title: "Subcategory", className: 'subcategory text-left font-size12 lh-normal', render: (data) => { return this.renderDeliverableChildItem(data, 2) } },
            { data: null, title: "Responsible User", className: 'responsible-user text-left font-size12 lh-normal', render: (data) => { return this.renderDeliverableChildItem(data, 4) } },
            {
                data: function (row: DeliverableChildExtended, type, val, meta) {
                    if (type === "sort") {
                        return row.LastUpdated;
                    }
                    else if (type === "display" || type === "filter") {
                        return getDisplayDate(row.LastUpdated);
                    }
                    return row.LastUpdated
                },
                title: "Last Updated",
                className: "last-updated text-left font-size12 nowrap"
            }
        ]

        this.currentParentChildElementTable = $(`#${id}`).DataTable({
            "dom": `<"${id}-top-controls"<"${id}-column-select"><"${id}-search-bar"f><"${id}-count-found"B>>rtip`,
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            //responsive: false,
            scrollY: '375px',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            language:
            {
                search: "Search",
                emptyTable: "No Matching Child Elements Found"
            },
            columns: tableColumns,
            buttons: [
                {
                    extend: 'csv',
                    filename: "revampp_child_deliverables",
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8'
                }
            ],
            data: this.currentParent.DeliverableChildren,
            order: [[5, 'desc']],
            initComplete: (settings, json) => {

            },
        });

        $(`.${id}-top-controls`).addClass('row mx-0 align-items-center');

        $(`.${id}-column-select`).addClass('col-12 col-md-3 px-0 mb-2');
        $(`.${id}-column-select`).empty().html(`<div id="${id}-column-select"></div>`);
        $(`.${id}-search-bar`).addClass('col-12 col-md-3');
        $(`.${id}-count-found`).addClass('col-12 col-md-6 d-flex justify-content-end vertical-align-middle mt-3 px-0');
        $(`.${id}-count-found`).prepend('<div id="selected-items-block" class="align-self-center pr-3"></div>');

        let tableColumnGroups: TableColumnGroup[] = [
            new TableColumnGroup("Center/Core/Project", true, [], "center-core-project"),
            new TableColumnGroup("Stage", true, [], "stage"),
            new TableColumnGroup("Subcategory", true, [], "subcategory"),
            new TableColumnGroup("Responsible Person", true, [], "responsible-user"),
            new TableColumnGroup("Last Updated", true, [], "last-updated")
        ]

        let childElementTableController = new TableColumnVisibilityControllerV2(`#${id}`, `#${id}-column-select`, tableColumnGroups, `${id}-table-column-visibility`);

        $(`#${id} tbody`).on('click', 'td', (event) => {
            let td = $(event.currentTarget);
            if (td.hasClass("inner-table-child-link")) {
                let tr = $(td).closest("tr");
                let row = this.currentParentChildElementTable.row(tr);
                let child: DeliverableChildExtended = row.data();

                if (child) {
                    this.currentChild = child;

                    // Update the Child Tab and open the tab
                    this.updateChildModalContent();
                    this.childTab.closest(".nav-item").removeClass("d-none");
                    this.childTab.tab("show");
                }
                return;
            }
        });
    }

    createParentStatusHistoryTable(): void {
        let id = `view-deliverable-history-table-${this.currentParent.DeliverableParent.Id}`;

        let tableColumns = [
            { data: null, title: "Description", className: `text-left font-size12 table-column-lg lh-normal inner-table-child-link`, render: (data: DeliverableStatusHistory) => { return this.renderStatusHistoryItem(data, 1) } },
            {
                data: function (row: DeliverableStatusHistory, type, val, meta) {
                    if (type === "sort") {
                        return row.Date;
                    }
                    else if (type === "display" || type === "filter") {
                        return getDisplayDate(row.Date);
                    }
                    return row.Date
                },
                title: "Date",
                className: "text-left font-size12 nowrap"
            },
            { data: null, title: "New Stage", className: 'text-left font-size12 lh-normal', render: (data) => { return this.renderStatusHistoryItem(data, 3) } },
            { data: null, title: "Previous Stage", className: 'text-left font-size12 lh-normal', render: (data) => { return this.renderStatusHistoryItem(data, 2) } },
            { data: null, title: "User", className: 'text-left font-size12 lh-normal', render: (data) => { return this.renderStatusHistoryItem(data, 4) } }
            
        ]

        this.currentParentStatusHistoryTable = $(`#${id}`).DataTable({
            "dom": `<"${id}-top-controls"<"${id}-search-bar"f><"${id}-count-found"B>>rtip`,
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            //responsive: false,
            scrollY: '375px',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            language:
            {
                search: "Search",
                emptyTable: "No Status History Updates"
            },
            columns: tableColumns,
            buttons: [
                {
                    extend: 'csv',
                    filename: "revampp_status_history",
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8'
                }
            ],
            data: this.currentParent.StatusHistory,
            order: [[1, 'desc']],
            initComplete: (settings, json) => {

            },
        });

        $(`.${id}-top-controls`).addClass('row mx-0 align-items-center');
        $(`.${id}-search-bar`).addClass('col-12 col-md-3 pl-0');
        $(`.${id}-count-found`).addClass('col-12 col-md-9 d-flex justify-content-end vertical-align-middle mt-3 px-0');
        $(`.${id}-count-found`).prepend('<div id="selected-items-block" class="align-self-center pr-3"></div>');

        $(`#${id} tbody`).on('click', 'td', (event) => {
            let td = $(event.currentTarget);
            if (td.hasClass("inner-table-child-link")) {
                let tr = $(td).closest("tr");
                let row = this.currentParentStatusHistoryTable.row(tr);
                let statusHistoryElement: DeliverableStatusHistory = row.data();

                if (statusHistoryElement) {
                    let child = this.currentParent.DeliverableChildren.find(c => c.DeliverableChild.Id == statusHistoryElement.ChildId);
                    if (child) {
                        this.currentChild = child;

                        // Update the Child Tab and open the tab
                        this.updateChildModalContent();
                        this.childTab.closest(".nav-item").removeClass("d-none");
                        this.childTab.tab("show");
                    }   
                }
                return;
            }
        });
    }

    createChildStatusHistoryTable(): void {
        let id = `view-child-deliverable-history-table-${this.currentChild.DeliverableChild.Id}`;

        let tableColumns = [
            { data: null, title: "Description", className: `text-left font-size12 table-column-lg lh-normal`, render: (data: DeliverableStatusHistory) => { return this.renderStatusHistoryItem(data, 1) } },
            {
                data: function (row: DeliverableStatusHistory, type, val, meta) {
                    if (type === "sort") {
                        return row.Date;
                    }
                    else if (type === "display" || type === "filter") {
                        return getDisplayDate(row.Date);
                    }
                    return row.Date
                },
                title: "Date",
                className: "text-left font-size12 nowrap"
            },
            { data: null, title: "New Stage", className: 'text-left font-size12 lh-normal', render: (data) => { return this.renderStatusHistoryItem(data, 3) } },
            { data: null, title: "Previous Stage", className: 'text-left font-size12 lh-normal', render: (data) => { return this.renderStatusHistoryItem(data, 2) } },
            { data: null, title: "User", className: "text-left font-size12 lh-normal", render: (data) => { return this.renderStatusHistoryItem(data, 4) } }

        ]

        this.currentChildStatusHistoryTable = $(`#${id}`).DataTable({
            "dom": `<"${id}-top-controls"<"${id}-search-bar"f><"${id}-count-found"B>>rtip`,
            autoWidth: true,
            info: false,
            paging: false,
            search: true,
            scrollX: true,
            //responsive: false,
            scrollY: '375px',
            scrollCollapse: true,
            orderCellsTop: true,
            fixedColumns: {
                leftColumns: 1
            },
            language:
            {
                search: "Search",
                emptyTable: "No Status History Updates"
            },
            columns: tableColumns,
            buttons: [
                {
                    extend: 'csv',
                    filename: "revampp_child_status_history",
                    text: '<i class="fas fa-file-download"></i>',
                    titleAttr: 'CSV',
                    charset: 'utf-8'
                }
            ],
            data: this.currentChild.StatusHistory,
            order: [[1, 'desc']],
            initComplete: (settings, json) => {

            },
        });

        $(`.${id}-top-controls`).addClass('row mx-0 align-items-center');
        $(`.${id}-search-bar`).addClass('col-12 col-md-3 pl-0');
        $(`.${id}-count-found`).addClass('col-12 col-md-9 d-flex justify-content-end vertical-align-middle mt-3 px-0');
        $(`.${id}-count-found`).prepend('<div id="selected-items-block" class="align-self-center pr-3"></div>');
    }

    async createParentAttachments(): Promise<any> {
        let parentId = this.currentParent?.DeliverableParent?.Id;
        if (!parentId) {
            return;
        }

        let result = await this.getAttachments(parentId.toString());
        if (result["items"]) {
            this.currentParentDocuments = JSON.parse(result["items"]);
        }

        // Map FolderId to child description
        this.currentParentDocuments.forEach(doc => {
            // Folder
            if (doc.type == 0) {
                let foundChild = this.currentParent.DeliverableChildren.find(child => child.DeliverableChild.Id.toString() == doc.text);
                if (foundChild) {
                    doc.text = foundChild.DeliverableChild.Description;
                }
            }
        })

        let treeId = `parent-attachments-${this.currentParent.DeliverableParent.Id}`;
        let iframeId = `deliverable-attachment-tab-content`;
        let tabId = `deliverable-attachment-tab`
        let documentTree = new DocumentTreeLoaderDeliverables(this.currentParentDocuments, treeId, `search-input-${treeId}`, `search-clear-${treeId}`, iframeId, tabId);
        
    }

    async createChildAttachments(): Promise<any> {
        let parentId = this.currentChild?.DeliverableChild?.ParentId;
        let childId = this.currentChild?.DeliverableChild?.Id;
        if (!childId || !parentId) {
            return;
        }

        let result = await this.getAttachments(parentId.toString(), childId.toString());
        if (result["items"]) {
            this.currentChildDocuments = JSON.parse(result["items"]);
        }

        let treeId = `child-attachments-${this.currentChild.DeliverableChild.Id}`;
        let iframeId = `deliverable-attachment-tab-content`;
        let tabId = `deliverable-attachment-tab`
        let documentTree = new DocumentTreeLoaderDeliverables(this.currentChildDocuments, treeId, `search-input-${treeId}`, `search-clear-${treeId}`, iframeId, tabId);
    }

    createStatusBar(): string {
        let displayIcon = `<i class="fa-regular fa-circle"></i>`;
        if (this.currentParent.IsOngoing) displayIcon = `<i class="fa-solid fa-circle-half-stroke"></i>`;
        else if (this.currentParent.IsComplete) displayIcon = `<i class="fa-solid fa-circle-check"></i>`;
        let totalCount = this.currentParent.DeliverableChildren.length;
        let completeCount = this.currentParent.DeliverableChildren.filter(child => child.IsComplete).length;
        let percentComplete: string = Math.round(100 * (completeCount / totalCount)).toString();

        let completedClass = "";
        if (this.currentParent.IsComplete) completedClass = "completed-bar";

        let returnContent = `
            <div class="modal-status-bar-wrapper">
                <div class="status-bar-container">
                    <div class="status-bar">
                        <div class="percent-complete-bar ${completedClass}" style="width:${percentComplete}%"></div>
                        <div class="percent-complete-text d-flex justify-content-between">
                            <div>
                                <span class="status-bar-icon">${displayIcon}</span>
                            </div>
                            <div>
                                ${completeCount} / ${totalCount}
                            </div>                          
                        </div>
                    </div>
                </div>
            </div>
            `
        return returnContent;
    }

    renderPickListItem(data: any, pickListName: string, isMultiple: boolean = false, isSorted: boolean = false, separator: string = ", "): string {
        if (!data) {
            return "";
        }

        let sortedPickList: PickListItemSorted[] = [];
        let pickList: PickListItem[] = [];

        if (isSorted) {
            let foundList: PickListItemSorted[] = this.pickLists.find(list => list.Id == pickListName)?.Json;
            if (foundList) {
                sortedPickList = foundList;
            }
        }
        else {
            let foundList: PickListItem[] = this.pickLists.find(list => list.Id == pickListName)?.Json;
            if (foundList) {
                pickList = foundList;
            }
        }

        if (sortedPickList.length == 0 && pickList.length == 0) {
            return "";
        }

        let returnStrArray: string[] = [];
        let returnStr: string = "";
        if (isMultiple) {
            let stringArrIds: string[] = data.split("|");
            stringArrIds = _.uniq(stringArrIds);

            for (let i = 0; i < stringArrIds.length; i++) {
                let numId: number = parseInt(stringArrIds[i]);
                if (numId) {
                    let foundItem = null;
                    if (isSorted) {
                        foundItem = sortedPickList.find(item => item.Id == numId);
                    }
                    else {
                        foundItem = pickList.find(item => item.Id == numId);
                    }

                    if (foundItem) {
                        returnStrArray.push(foundItem.Value);
                    }
                }
            }

            returnStrArray.sort();
            returnStr = returnStrArray.join(separator);
        }
        else {
            let foundItem = null;
            if (isSorted) {
                foundItem = sortedPickList.find(item => item.Id == data);
            }
            else {
                foundItem = pickList.find(item => item.Id == data);
            }

            if (foundItem) {
                returnStr = foundItem.Value;
            }
        }

        return returnStr;
    }

    renderDeliverableItem(data: DeliverableParentExtended, typeId: number): string {
        // Furthest Stage
        if (typeId == 1) {
            if (!data.FurthestStageId) {
                return "";
            }

            let stageList: PickListItemSorted[] = [];
            // Vaccine
            if (data.DeliverableParent.CategoryId == 1) {
                let foundList = this.pickLists.find(list => list.Id == "pl-stage-vaccine")?.Json;
                if (foundList) stageList = foundList;
            }
            else if (data.DeliverableParent.CategoryId == 2) {
                let foundList = this.pickLists.find(list => list.Id == "pl-stage-antibody")?.Json;
                if (foundList) stageList = foundList;
            }
            else if (data.DeliverableParent.CategoryId == 3) {
                let foundList = this.pickLists.find(list => list.Id == "pl-stage-knowledge")?.Json;
                if (foundList) stageList = foundList;
            }
            else if (data.DeliverableParent.CategoryId == 4) {
                let foundList = this.pickLists.find(list => list.Id == "pl-stage-coord")?.Json;
                if (foundList) stageList = foundList;
            }

            let foundItem = stageList.find(item => item.Id == data.FurthestStageId);
            if (foundItem) {
                return foundItem.Value;
            }
            else {
                return "";
            }
        }

        // Timeline Tab
        if (typeId == 2) {
            let actualStartDisplay = getDisplayDate(data.DeliverableParent.ActualStartDate);
            if (actualStartDisplay == "") {
                actualStartDisplay = "Not Specified";
            }

            let actualEndDisplay = getDisplayDate(data.DeliverableParent.ActualEndDate);
            if (actualEndDisplay == "") {
                actualEndDisplay = "Not Specified";
            }

            let content = `
                <div class="deliverable-modal-inner-tab-title">
                    Timeline
                </div>
                <div class="row mt-4">
                    <div class="col">
                        <div class="row align-items-center">
                            <div class="col-auto">
                                <div class="pill-list-container">
                                    <div class="pill-list-label" style="font-size: 14px">
                                        <span class="pill-list-icon light-blue"></span>
                                        Planned Timeline
                                    </div>
                                </div>
                                <div class="modal-timeline-block">
                                    <div class="mb-2">
                                        <span class="font-weight-500 pr-2">Planned Start: </span> ${getDisplayDate(data.DeliverableParent.PlannedStartDate)}
                                    </div>
                                    <div> 
                                        <span class="font-weight-500 pr-2">Planned End: </span> ${getDisplayDate(data.DeliverableParent.PlannedEndDate)}
                                    </div>
                                </div>
                            </div>
                            <div class="col-auto">
                                <div class="pill-list-container">
                                    <div class="pill-list-label" style="font-size: 14px">
                                        <span class="pill-list-icon"></span>
                                        Actual Timeline
                                    </div>
                                </div>
                                <div class="modal-timeline-block">
                                    <div class="mb-2">
                                        <span class="font-weight-500 pr-2">Actual Start: </span> ${actualStartDisplay}
                                    </div>
                                    <div> 
                                        <span class="font-weight-500 pr-2">Actual End: </span> ${actualEndDisplay}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto">
                        <div class="text-right"><span class="font-weight-500 pr-2">Project Year: </span> ${this.renderPickListItem(data.ProjectYearIds, "pl-project-year", true, false)}</div>
                    </div>
                </div>
                <div class="mt-3">
                    <figure class="highcharts-figure" style="width:100%;">
                        <div id="deliverables-parent-timeline-chart"></div>
                    </figure>
                </div>
            `;
            return content;
        }

        // Virus Focus Tab
        if (typeId == 3) {
            let parent = this.currentParent.DeliverableParent;

            let familyFocusContent = ""
            if (this.currentParent.VirusFamilyIds) {
                familyFocusContent = `
                    <div class="pill-list-container mb-3">
                        <div class="pill-list-label">
                            <span class="pill-list-icon light-blue"></span>
                            Virus Family Focus
                        </div>
                        <div class="row">
                            ${this.generatePillContent(this.currentParent.VirusFamilyIds, "pl-virus", "light-blue")}
                        </div>
                    </div>
                `
            }

            let prototypeFocusContent = "";
            if (parent.PrototypeVirusIds) {
                prototypeFocusContent = `
                    <div class="pill-list-container mb-3">
                        <div class="pill-list-label">
                            <span class="pill-list-icon light-green"></span>
                            Prototype Virus Focus
                        </div>
                        <div class="row">
                            ${this.generatePillContent(parent.PrototypeVirusIds, "pl-virus", "light-green")}
                        </div>
                    </div>
                `
            }

            let testFocusContent = "";
            if (parent.TestVirusIds) {
                testFocusContent = `
                    <div class="pill-list-container mb-3">
                        <div class="pill-list-label">
                            <span class="pill-list-icon yellow"></span>
                            Test Case Virus Focus
                        </div>
                        <div class="row">
                            ${this.generatePillContent(parent.TestVirusIds, "pl-virus", "yellow")}
                        </div>
                    </div>
                `
            }

            let targetContent = "";
            if (parent.TargetIds) {
                targetContent = `
                    <div class="pill-list-container mb-3">
                        <div class="pill-list-label">
                            <span class="pill-list-icon dark-blue"></span>
                            Virus Targets
                        </div>
                        <div class="row">
                            ${this.generatePillContent(parent.TargetIds, "pl-virus-target", "dark-blue")}
                        </div>
                    </div>
                `
            }

            let content = `
                <div class="deliverable-modal-inner-tab-title">
                    Virus Focus
                </div>
                <div class="mt-4">
                    ${familyFocusContent}
                    ${prototypeFocusContent}
                    ${testFocusContent}
                    ${targetContent}
                </div>
            `;
            return content;
        }

        // Child Elements Tab
        if (typeId == 4) {
            let childElementsCountText = "Child Elements";
            if (this.currentParent.DeliverableChildren.length == 1) {
                childElementsCountText = "Child Element";
            }

            let content = `
                <div class="d-flex justify-content-between">
                    <div class="deliverable-modal-inner-tab-title">
                        Child Elements
                    </div>
                    <div class="text-right">
                        <span class="font-italic" id="view-deliverable-child-found-count">${this.currentParent.DeliverableChildren.length} ${childElementsCountText}</span>
                    </div>
                </div>
                <div class="list-table-container mt-3">
                    <div class="revampp-datatable border-bottom" id="view-deliverable-children-table-${this.currentParent.DeliverableParent.Id}-container">
                        <table id="view-deliverable-children-table-${this.currentParent.DeliverableParent.Id}" class="table table-striped selectable-rows w-100" style="width:100%"></table>
                    </div>
                </div>
            `;
            return content;
        }

        // Status History Tab
        if (typeId == 5) {
            let countText = "Status Updates";
            if (this.currentParent.StatusHistory.length == 1) {
                countText = "Status Update";
            }

            let content = `
                <div class="d-flex justify-content-between">
                    <div class="deliverable-modal-inner-tab-title">
                        Staus History
                    </div>
                    <div class="text-right">
                        <span class="font-italic" id="view-deliverable-status-history-found-count">${this.currentParent.StatusHistory.length} ${countText}</span>
                    </div>
                </div>
                <div class="list-table-container mt-3">
                    <div class="revampp-datatable border-bottom" id="view-deliverable-history-table-${this.currentParent.DeliverableParent.Id}-container">
                        <table id="view-deliverable-history-table-${this.currentParent.DeliverableParent.Id}" class="table table-striped selectable-rows w-100" style="width:100%"></table>
                    </div>
                </div>
            `;
            return content;
        }

        // Attachments
        if (typeId == 6) {
            let id = `parent-attachments-${this.currentParent.DeliverableParent.Id}`;

            let content = `
                <div class="deliverable-modal-inner-tab-title">
                    Attachments
                </div>
                <div class="mt-4 document-library-page">
                    <div class="mb-4">
                        <div class="my-2 pb-3 h-100 bg-gainsboro document-tree-container">
                            <div class="py-3 px-4 mb-3 d-flex justify-content-between align-items-center file-search-bar">
                                <div class="file-date-filter d-flex align-items-center">
                                    <select id="date-filter-${id}" class="selectpicker dropdown" data-width="100%" data-container="body" data-size="4" data-title="Filter by Last Updated">
                                        <option value="0">All Documents</option>
                                        <option value="8">Updated in Past 7 Days</option>
                                        <option value="15">Updated in Past 14 Days</option>
                                        <option value="31">Updated in Past 30 Days</option>
                                        <option value="61">Updated in Past 60 Days</option>
                                    </select>
                                    <div class="pl-2">
                                        <i class="fas fa-calendar-alt fa-lg white-icon"></i>
                                    </div>
                                </div>
                                <div class="input-group jstree-file-search pl-2">
                                    <input id="search-input-${id}" type="text" class="form-control font-size14" placeholder="Search for files...">
                                    <div class="input-group-append">
                                        <button class="btn btn-secondary font-size14" type="button" id="search-clear-${id}">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div id="file-display-container-${id}" class="file-display-container pl-3 pr-2">
                                <div id="${id}" class="jstree">
                                    <div class="p-2 text-center">
                                        <div class="text-center pb-1 font-size14 font-weight-500">Loading Attachments</div>
                                        <div class="text-center">
                                            <div class="spinner-border spinner-border-sm" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            return content;
        }

        // Comments
        else if (typeId == 7) {
            let currentComments = "";
            let parentComments = data.Comments;
            if (parentComments.length == 0) {
                currentComments = `<div class='text-center font-size16 font-weight-500 pb-3'>No Comments</div>`;
            }
            else {
                let userList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-users")?.Json;
                if (userList) {
                    parentComments.sort((x1, x2) => {
                        let time1 = new Date(x1.Date).getTime();
                        let time2 = new Date(x2.Date).getTime();
                        return time2 - time1;
                    })
                    parentComments.forEach(comment => {
                        let foundUser = userList.find(user => user.Id == comment.AppUserId);
                        let userInfo = "";
                        if (foundUser) {
                            userInfo = foundUser.Value;
                        }

                        let displayTitle = "";
                        let foundChild = this.currentParent.DeliverableChildren.find(child => child.DeliverableChild.Id == comment.ChildId);
                        if (foundChild) {
                            displayTitle = foundChild.DeliverableChild.Description;
                        }

                        let commentContent = `
                        <div class="deliverable-comment-row">
                            <div class="d-flex justify-content-between">
                                <div class="deliverable-comment-user">${userInfo}</div>
                                <div class="deliverable-comment-date">${getDisplayDate(comment.Date)}</div>
                            </div>
                            <div class="deliverable-comment-subtitle">
                                <span class="comment-child-link" data-child-id="${comment.ChildId}">${displayTitle}</span>
                            </div>
                            <div class="deliverable-comment-comment"> 
                                ${comment.Comment}
                            </div>
                        </div>  
                        `
                        currentComments += commentContent;
                    });
                }
            }

            let returnContent = `
                <div class="deliverable-modal-inner-tab-title">
                    Comments
                </div>
                <div class="mt-4">
                    <div class="deliverable-comment-table">
                        ${currentComments}
                    </div>
                </div>
            `

            return returnContent;
        }
    }

    renderDeliverableChildItem(data: DeliverableChildExtended, typeId: number) {
        // Stage
        if (typeId == 1) {
            if (!data.DeliverableChild.StageId) {
                return "";
            }

            let stageList: PickListItemSorted[] = [];
            // Vaccine
            if (data.DeliverableChild.CategoryId == 1) {
                let foundList = this.pickLists.find(list => list.Id == "pl-stage-vaccine")?.Json;
                if (foundList) stageList = foundList;
            }
            else if (data.DeliverableChild.CategoryId == 2) {
                let foundList = this.pickLists.find(list => list.Id == "pl-stage-antibody")?.Json;
                if (foundList) stageList = foundList;
            }
            else if (data.DeliverableChild.CategoryId == 3) {
                let foundList = this.pickLists.find(list => list.Id == "pl-stage-knowledge")?.Json;
                if (foundList) stageList = foundList;
            }
            else if (data.DeliverableChild.CategoryId == 4) {
                let foundList = this.pickLists.find(list => list.Id == "pl-stage-coord")?.Json;
                if (foundList) stageList = foundList;
            }

            let foundItem = stageList.find(item => item.Id == data.DeliverableChild.StageId);
            if (foundItem) {
                return foundItem.Value;
            }
            else {
                return "";
            }
        }

        // Subcategories
        else if (typeId == 2) {
            if (!data.DeliverableChild.SubcategoryIds) {
                return "";
            }

            let subcategoryList: PickListItemSorted[] = [];
            // Vaccine
            if (data.DeliverableChild.CategoryId == 1) {
                let foundList = this.pickLists.find(list => list.Id == "pl-subcategory-vaccine")?.Json;
                if (foundList) subcategoryList = foundList;
            }
            else if (data.DeliverableChild.CategoryId == 2) {
                let foundList = this.pickLists.find(list => list.Id == "pl-subcategory-antibody")?.Json;
                if (foundList) subcategoryList = foundList;
            }
            else if (data.DeliverableChild.CategoryId == 3) {
                let foundList = this.pickLists.find(list => list.Id == "pl-subcategory-knowledge")?.Json;
                if (foundList) subcategoryList = foundList;
            }
            else if (data.DeliverableChild.CategoryId == 4) {
                let foundList = this.pickLists.find(list => list.Id == "pl-subcategory-coord")?.Json;
                if (foundList) subcategoryList = foundList;
            }

            let subCatArray: string[] = data.DeliverableChild.SubcategoryIds.split("|");
            let returnVals: string[] = [];
            subCatArray.forEach(subcat => {
                let foundItem = subcategoryList.find(item => item.Id.toString() == subcat);
                if (foundItem) {
                    returnVals.push(foundItem.Value);
                }
            })

            returnVals.sort();
            return returnVals.join(", ");
        }

        // Center/Core/Project
        else if (typeId == 3) {
            let returnVal = "";
            if (data.DeliverableChild.CoreId > 0) {
                let pickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-core")?.Json;
                if (pickList) {
                    let foundItem = pickList.find(item => item.Id == data.DeliverableChild.CoreId);
                    if (foundItem) {
                        let strArr = foundItem.Value.split(" - ");
                        strArr[0] = `<i>${strArr[0]}</i>`
                        returnVal = strArr.join("<br>");
                    }
                }
            }
            else if (data.DeliverableChild.ProjectId > 0) {
                let pickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-project")?.Json;
                if (pickList) {
                    let foundItem = pickList.find(item => item.Id == data.DeliverableChild.ProjectId);
                    if (foundItem) {
                        let strArr = foundItem.Value.split(" - ");
                        strArr[0] = `<i>${strArr[0]}</i>`
                        returnVal = strArr.join("<br>");
                    }
                }
            }
            else if (data.DeliverableChild.CenterId > 0) {
                let pickList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-center")?.Json;
                if (pickList) {
                    let foundItem = pickList.find(item => item.Id == data.DeliverableChild.CenterId);
                    if (foundItem) {
                        returnVal = foundItem.Value;
                    }
                }
            }

            return returnVal;
        }


        // Responsible Person
        else if (typeId == 4) {
            let user = data.ResponsibleAppUser?.AppUser;
            let returnVal = "";
            if (user) {
                returnVal = `${user.LastName}, ${user.FirstName} (${user.Email})`;
            }
            return returnVal;
        }

        // Overview content 
        else if (typeId == 5) {
            let responsiblePersonContent = "";
            if (data.ResponsibleAppUser?.AppUser) {
                let user = data.ResponsibleAppUser.AppUser;
                let displayName = `${user.FirstName} ${user.LastName}`;
                if (user.TerminalDegreeIds) {
                    let terminalDegreeString = this.renderPickListItem(user.TerminalDegreeIds, "pl-degree", true, false);
                    displayName += `, ${terminalDegreeString}`
                }
                let displayRole = "";
                if (data.ResponsibleAppUser.AppUserAffiliationList.length > 0) {
                    let roleNamesArr: string[] = [];
                    data.ResponsibleAppUser.AppUserAffiliationList.forEach(affiliation => {
                        let roleName = this.renderPickListItem(affiliation.RoleId, "pl-member-roles", false, false);
                        if (roleName) roleNamesArr.push(roleName);
                    });
                    roleNamesArr = _.uniq(roleNamesArr);
                    roleNamesArr.sort();
                    displayRole = roleNamesArr.join(", ");
                }
                let iconLinks = "";
                if (user.Email) {
                    iconLinks += `<div class="col-auto"><a href="mailto:${user.Email}" target="_blank" style="color: white;"><i class="fa-solid fa-envelope fa-2x"></i></a></div>`
                }
                if (user.OrcidLink) {
                    iconLinks += `<div class="col-auto"><a href="${user.OrcidLink}" target="_blank" style="color: #a5ce39;"><i class="fab fa-orcid fa-2x"></i></a></div>`
                }
                if (user.LinkedinLink) {
                    iconLinks += `<div class="col-auto"><a href="${user.LinkedinLink}" target="_blank" style="color: white;"><i class="fab fa-linkedin fa-2x"></i></a></div>`
                }

                responsiblePersonContent = `
                    <div class="col-lg-3 col-md-4 col-12">
                        <div class="deliverables-inner-subtitle">Responsible Person</div>
                        <div class="overview-blue-card">
                            <div class="overview-title">${displayName}</div>
                            <div class="overview-subtitle mt-2">${displayRole}</div>
                            <div class="row align-items-center mt-3">
                                ${iconLinks}
                            </div>
                        </div>
                    </div>
                `
            }

            let centerContent = "";
            if (data.DeliverableChild.CoreId || data.DeliverableChild.ProjectId) {
                let centerName = this.renderPickListItem(data.DeliverableChild.CenterId, "pl-center", false, false);
                let coreProjectName = "";
                if (data.DeliverableChild.CoreId) {
                    coreProjectName = this.renderPickListItem(data.DeliverableChild.CoreId, "pl-core", false, false);
                    coreProjectName = coreProjectName.split(" - ")[1];
                }
                else if (data.DeliverableChild.ProjectId) {
                    coreProjectName = this.renderPickListItem(data.DeliverableChild.ProjectId, "pl-project", false, false);
                    coreProjectName = coreProjectName.split(" - ")[1];
                }
                centerContent = `
                    <div class="col-lg-3 col-md-4 col-12">
                        <div class="deliverables-inner-subtitle">Center</div>
                        <div class="overview-blue-card">
                            <div class="overview-title">${centerName}</div>
                            <div class="overview-subtitle mt-2">${coreProjectName}</div>
                        </div>
                    </div>
                `
            }


            let subcategoryContent = "";
            if (data.DeliverableChild.SubcategoryIds) {
                let subcategoryPills = "";
                let subcategoryArr: string[] = this.renderDeliverableChildItem(data, 2).split(", ");
                subcategoryArr.sort();
                subcategoryArr.forEach(subcat => {
                    subcategoryPills += `<div class="pill-list-item white">${subcat}</div>`
                })
                subcategoryContent = `
                    <div class="col ml-md-4">
                        <div class="pill-list-container mb-3">
                            <div class="pill-list-label">
                                <span class="pill-list-icon white"></span>
                                Subcategory
                            </div>
                            <div class="row px-3">
                                ${subcategoryPills}
                            </div>
                        </div>
                    </div>
                `
            }
            let content = `
                <div class="deliverable-modal-inner-tab-title">
                    Overview
                </div>
                <div class="row mt-4">
                    ${responsiblePersonContent}
                    ${centerContent}
                    ${subcategoryContent}
                </div>
            `;
            return content;
        }

        // Attachments
        else if (typeId == 6) {
            let id = `child-attachments-${this.currentChild.DeliverableChild.Id}`;

            let content = `
                <div class="deliverable-modal-inner-tab-title">
                    Attachments
                </div>
                <div class="mt-4 document-library-page">
                    <div class="mb-4">
                        <div class="my-2 pb-3 h-100 bg-gainsboro document-tree-container">
                            <div class="py-3 px-4 mb-3 d-flex justify-content-between align-items-center file-search-bar">
                                <div class="file-date-filter d-flex align-items-center">
                                    <select id="date-filter-${id}" class="selectpicker dropdown" data-width="100%" data-container="body" data-size="4" data-title="Filter by Last Updated">
                                        <option value="0">All Documents</option>
                                        <option value="8">Updated in Past 7 Days</option>
                                        <option value="15">Updated in Past 14 Days</option>
                                        <option value="31">Updated in Past 30 Days</option>
                                        <option value="61">Updated in Past 60 Days</option>
                                    </select>
                                    <div class="pl-2">
                                        <i class="fas fa-calendar-alt fa-lg white-icon"></i>
                                    </div>
                                </div>
                                <div class="input-group jstree-file-search pl-2">
                                    <input id="search-input-${id}" type="text" class="form-control font-size14" placeholder="Search for files...">
                                    <div class="input-group-append">
                                        <button class="btn btn-secondary font-size14" type="button" id="search-clear-${id}">
                                            <i class="fas fa-times"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div id="file-display-container-${id}" class="file-display-container pl-3 pr-2">
                                <div id="${id}" class="jstree">
                                    <div class="p-2 text-center">
                                        <div class="text-center pb-1 font-size14 font-weight-500">Loading Attachments</div>
                                        <div class="text-center">
                                            <div class="spinner-border spinner-border-sm" role="status">
                                                <span class="sr-only">Loading...</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `;
            return content;
        }

        // Comments
        else if (typeId == 7) {
            let currentComments = "";
            let childComments = data.Comments;
            if (childComments.length == 0) {
                currentComments = `<div class='text-center font-size16 font-weight-500 pb-3'>No Comments</div>`;
            }
            else {
                let userList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-users")?.Json;
                if (userList) {
                    childComments.sort((x1, x2) => {
                        let time1 = new Date(x1.Date).getTime();
                        let time2 = new Date(x2.Date).getTime();
                        return time2 - time1;
                    })
                    childComments.forEach(comment => {
                        let foundUser = userList.find(user => user.Id == comment.AppUserId);
                        let userInfo = "";
                        if (foundUser) {
                            userInfo = foundUser.Value;
                        }

                        let commentContent = `
                        <div class="deliverable-comment-row">
                            <div class="d-flex justify-content-between">
                                <div class="deliverable-comment-user">${userInfo}</div>
                                <div class="deliverable-comment-date">${getDisplayDate(comment.Date)}</div>
                            </div>
                            <div class="deliverable-comment-comment"> 
                                ${comment.Comment}
                            </div>
                        </div>  
                    `
                        currentComments += commentContent;
                    });
                }
            }

            let returnContent = `
                <div class="deliverable-modal-inner-tab-title">
                    Comments
                </div>
                <div class="mt-4">
                    <div class="deliverable-comment-table">
                        ${currentComments}
                    </div>
                </div>
            `

            return returnContent;
        }

        // Status History
        else if (typeId == 8) {
            let countText = "Status Updates";
            if (data.StatusHistory.length == 1) {
                countText = "Status Update";
            }

            let content = `
                <div class="d-flex justify-content-between">
                    <div class="deliverable-modal-inner-tab-title">
                        Staus History
                    </div>
                    <div class="text-right">
                        <span class="font-italic" id="view-child-deliverable-status-history-found-count">${data.StatusHistory.length} ${countText}</span>
                    </div>
                </div>
                <div class="list-table-container mt-3">
                    <div class="revampp-datatable border-bottom" id="view-child-deliverable-history-table-${data.DeliverableChild.Id}-container">
                        <table id="view-child-deliverable-history-table-${data.DeliverableChild.Id}" class="table table-striped selectable-rows w-100" style="width:100%"></table>
                    </div>
                </div>
            `;
            return content;
        }
    }

    renderStatusHistoryItem(data: DeliverableStatusHistory, typeId: number): string {
        // Description
        if (typeId == 1) {
            let returnVal = "";
            let childId: number = data.ChildId;
            let foundChild = this.currentParent.DeliverableChildren.find(child => child.DeliverableChild.Id == childId);
            if (foundChild) {
                returnVal = foundChild.DeliverableChild.Description;
            }
            return returnVal;
        }

        // Stage (2 = previous, 3 = new)
        if (typeId == 2 || typeId == 3) {
            let returnVal = "";
            let childId: number = data.ChildId;
            let foundChild = this.currentParent.DeliverableChildren.find(child => child.DeliverableChild.Id == childId);
            if (foundChild) {
                let stageList: PickListItemSorted[] = [];
                // Vaccine
                if (foundChild.DeliverableChild.CategoryId == 1) {
                    let foundList = this.pickLists.find(list => list.Id == "pl-stage-vaccine")?.Json;
                    if (foundList) stageList = foundList;
                }
                else if (foundChild.DeliverableChild.CategoryId == 2) {
                    let foundList = this.pickLists.find(list => list.Id == "pl-stage-antibody")?.Json;
                    if (foundList) stageList = foundList;
                }
                else if (foundChild.DeliverableChild.CategoryId == 3) {
                    let foundList = this.pickLists.find(list => list.Id == "pl-stage-knowledge")?.Json;
                    if (foundList) stageList = foundList;
                }
                else if (foundChild.DeliverableChild.CategoryId == 4) {
                    let foundList = this.pickLists.find(list => list.Id == "pl-stage-coord")?.Json;
                    if (foundList) stageList = foundList;
                }

                if (typeId == 2) {
                    let foundItem = stageList.find(item => item.Id == data.PreviousStatusId);
                    if (foundItem) {
                        returnVal = foundItem.Value;
                    }
                }
                else if (typeId == 3) {
                    let foundItem = stageList.find(item => item.Id == data.NewStatusId);
                    if (foundItem) {
                        returnVal = foundItem.Value;
                    }
                }
             
            }
            return returnVal;
        }

        // Responsible Person
        else if (typeId == 4) {
            let userId = data.AppUserId;
            let userList: PickListItem[] = this.pickLists.find(list => list.Id == "pl-users")?.Json;
            let returnVal = "";
            if (userList) {
                let foundUser = userList.find(item => item.Id == userId);
                if (foundUser) {
                    returnVal = foundUser.Value;
                }
            }
            return returnVal;
        }
    }

    generatePillContent(idString: string, pickList: string, color: string): string {
        if (idString == null || idString == "") {
            return "<div class='error-msg col-auto'>--Not Specified--</div>"
        }
        let foundPickList: PickListItem[] = this.pickLists.find(list => list.Id == pickList)?.Json;
        if (!foundPickList) {
            return "<div class='error-msg col-auto'>--No Pick List Found--</div>"
        }

        let idArr: string[] = idString.split("|");
        let valArr: string[] = [];
        let returnContent: string = ``;
        idArr.forEach(id => {
            let foundItem = foundPickList.find(item => item.Id.toString() == id);
            if (foundItem) {
                valArr.push(foundItem.Value);
            }
        });
        valArr.sort();
        valArr.forEach(val => {
            if (pickList != "pl-virus-target") {
                returnContent += `
                <div class="col-auto pr-0 mb-2">
                    <div class="pill-list-item ${color}">${val}</div>
                </div>`
            }
            else {
                let valArr = val.split(" - ");
                if (valArr.length >= 2) {
                    let familyPart = valArr[0];
                    let targetPart = valArr[1];
                    returnContent += `
                    <div class="col-auto pr-0 mb-2">
                        <div class="pill-list-item ${color} text-center">
                            ${targetPart}<br>
                            <span class="font-italic font-size12">${familyPart}</span>
                        </div>
                    </div>`
                }
            }
            
        })

        if (returnContent == "") {
            return "<div class='error-msg col-auto'>--Not Specified--</div>";
        }
        return returnContent;
    }

    async getAttachments(parentId: string, childId: string = "") {
        let result: any;
        try {
            result = await $.ajax(this.getAttachmentsRoute, {
                method: "POST",
                headers: { "RequestVerificationToken": <string>$('input[name="__RequestVerificationToken"]').val() },
                data: { parentId: parentId, childId: childId }
            });
            return result;
        }
        catch (error) {
            alert("An error has occurred, please refresh the page and try again.");
            console.log(error);
        }
    }
}


